import { module } from 'angular';
import { StorageService } from './storage/storage.service';
import { StorageServiceProvider } from './storage/storage.service.provider';

export const CoreProvidersModule = module('app.core.providers', [])
  .provider(StorageService.name, StorageServiceProvider);



// WEBPACK FOOTER //
// ./app/core/providers/core-providers.module.ts